<template>
  <div class="login">
    <div class="login.content">
      <h2>兰州科技后台管理系统</h2>
      <div class="login.form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item prop="userName">
            <el-input
              prefix-icon="fa fa-user"
              type="text"
              v-model="ruleForm.userName"
              autocomplete="off"
              placeholder="用户名/手机号"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="fa fa-unlock-alt"
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
              placeholder="密码"
              @keyup.enter.native="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="login.btn" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import MD5 from 'md5'
export default {
  data() {
    return {
      ruleForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        var password = MD5(this.ruleForm.userName.trim()+this.ruleForm.password.trim()).toUpperCase()
          this.$store
            .dispatch('Login', {
              username: this.ruleForm.userName.trim().replace(/\s+/g, ''),
              password: password,
              type: 2
            })
            .then(res => {
              this.getMenuList();

              //  this.$router.replace("/home");
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getMenuList() {
      const roleId = this.$store.getters.userInfo?JSON.parse(this.$store.getters.userInfo).roleId: 0;
      if (roleId!= 0) {
        this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/system/admin-role/get?id=${roleId}`).then(res => {
          let arr = res.data.menuIds || res.data.menu_ids || [];
          console.log('arr', arr);
          let index = arr.findIndex(item => {
            return item.name === '首页';
          });
          console.log('index', index);
          localStorage.setItem('showHome', index);
           this.$store.dispatch('getnewsList');

          if (index === -1) {
            // 无首页
            if (arr[0].children && arr[0].children.length > 0) {
              this.$router.replace(arr[0].children[0].url);
            } else {
              this.$router.replace(arr[0].url);
            }
          } else {
            // 有首页
            this.$router.replace('/home');
          }

          // this.menuLists = this.home.concat(res.data.menu_ids);
        });
      } else {
        // this.menuLists = this.home
      }
    }
  }
};
</script>

<style lang="scss">
@include component(login) {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: url(../assets/error-bg.jpeg);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;

  @include part(content) {
    width: 360px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > h2 {
      font-size: 30px;
      margin: 0;
      opacity: 0.8;
      margin-bottom: 32px;
    }
  }

  @include part(form) {
    width: 100%;
    height: 270px;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
    padding: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;

    form {
      width: 100%;
    }

    @include component(el-form-item__content) {
      margin-left: 0 !important;
    }
  }

  @include part(btn) {
    width: 100%;
    color: #fff;
    background: linear-gradient(to bottom right, #9853af, #623aa2);
    border-color: #913ad8;

    &:active,
    &:hover {
      color: #fff;
    }
  }
}
</style>
